import { useSelector } from 'react-redux';
import { CompanyPlanLevel, CompanyPlanStatus } from '../enum/CompanyPlanLevelEnum';

type UseCanUseOutsourcedOrdersModuleResult = {
  canConfigureOutsourcedOrdersModule: boolean;
  canUseOutsourcedOrdersModule: boolean;
  isOutsourcedOrdersModuleEnabled: boolean;
};

const useCanUseOutsourcedOrdersModule = (
  storeId: string
): UseCanUseOutsourcedOrdersModuleResult => {
  void storeId;
  const { company } = useSelector((state: any) => state.user);
  const isInGraceOrSuspended = [CompanyPlanStatus.GRACE, CompanyPlanStatus.SUSPENDED].includes(
    company?.planStatus
  );
  const isStandardOrPremium = [CompanyPlanLevel.STANDARD, CompanyPlanLevel.PREMIUM].includes(
    company?.planLevel
  );
  const canConfigureOutsourcedOrdersModule = isStandardOrPremium && !isInGraceOrSuspended;
  const isOutsourcedOrdersModuleEnabled =
    company?.companyServicesPermissions?.enableOutsourcing === true;

  return {
    canConfigureOutsourcedOrdersModule,
    canUseOutsourcedOrdersModule:
      canConfigureOutsourcedOrdersModule && isOutsourcedOrdersModuleEnabled,
    isOutsourcedOrdersModuleEnabled
  };
};

export default useCanUseOutsourcedOrdersModule;
